export default ngModule => {
    ngModule.directive('saveQuote', (AonConfig) => {
        return {
            restrict: 'E',
            scope: {
                visible: '=',
                onClose: '=',
                applicant: '=',
                onSave: '=',
            },
            template: require('./save-quote.html'),
            link: (scope) => {
                scope.showAdditionDetails = AonConfig.corporate.show_additional_details_on_quote === true;
                scope.emailAndSMSRequired = !AonConfig.corporate.quote_sms_and_email_optional;

                scope.$watch('visible', () => {
                    if (scope.visible) {
                        $('#save-quote.modal').modal();
                    } else {
                        $('#save-quote.modal').modal('hide');
                    }

                    if (scope.visible && scope.saveQuoteForm) {
                        const email = _.get(scope.applicant, 'contact.email_address', null);
                        const mobile = _.get(scope.applicant, 'contact.phone_mobile', null);
                        const expectedYearlySavings = _.get(scope.applicant, 'zoho.expected_yearly_savings', 0);
                        scope.saveQuoteForm.sendSMS = !!mobile;
                        scope.saveQuoteForm.sendEmail = !!email;
                        scope.saveQuoteForm.expectedYearlySavings = expectedYearlySavings;
                        scope.saveQuoteForm.improvedBenefit1 = '';
                        scope.saveQuoteForm.improvedBenefit2 = '';
                        scope.saveQuoteForm.improvedBenefit3 = '';
                    }
                });

                scope.saveQuoteFormValid = (form) => {
                    // Since fields are not editable, the selections should match what data we have for the opportunity
                    const email = _.get(scope.applicant, 'contact.email_address', null);
                    const mobile = _.get(scope.applicant, 'contact.phone_mobile', null);
                    const sendOptionsValid = scope.emailAndSMSRequired
                      ? ((!!email == form.sendEmail) && (!!mobile == form.sendSMS))
                      : ((!form.sendEmail || !!email) && (!form.sendSMS || !!mobile));
                    const expectedSavingsValid = (
                        !scope.showAdditionDetails ||
                        !isNaN(parseInt(scope.saveQuoteForm.expectedYearlySavings))
                    );
                    const improvedBenefitValid = !scope.showAdditionDetails || (
                        !!scope.saveQuoteForm.improvedBenefit1 ||
                        !!scope.saveQuoteForm.improvedBenefit2 ||
                        !!scope.saveQuoteForm.improvedBenefit3
                    );
                    return (
                        sendOptionsValid &&
                        expectedSavingsValid &&
                        improvedBenefitValid
                    );
                };
            }
        };
    });
}



// WEBPACK FOOTER //
// ./src/directives/save-quote.js